import { useTranslation } from "react-i18next";
import { Zap } from "lucide-react";
import { clsx } from "clsx";
import { useDevice } from "./device";
import { usePopover } from "../ui";

/** "My energy now" (spec §9.19): a per-device 1–5 control in the *Wants doing* header, which it filters (I-7);
 * it sat in the top bar and looked as if it filtered everything (UI cleanup U2). */
export function EnergyControl() {
  const { t } = useTranslation();
  const energy = useDevice((s) => s.energy);
  const setEnergy = useDevice((s) => s.setEnergy);
  const { open, toggle, setOpen, ref } = usePopover<HTMLDivElement>();
  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={t("energy.myEnergy")}
        data-testid="energy-control"
        onClick={toggle}
        className="inline-flex h-[30px] items-center gap-1.5 rounded-sm border border-neutral-200 bg-[var(--surface)] px-2 text-[13px] text-neutral-700 hover:border-neutral-700 dark:border-neutral-800 dark:text-neutral-200"
      >
        <Zap size={13} aria-hidden />
        <span className="font-mono">{energy ?? "–"}</span>
      </button>
      {open && (
        <ul
          role="listbox"
          aria-label={t("energy.myEnergy")}
          className="absolute left-0 top-9 z-40 w-56 rounded-md border border-neutral-200 bg-[var(--surface)] p-1 text-sm shadow-[var(--shadow-md)] dark:border-neutral-700"
        >
          <li className="px-2 py-1 text-xs font-semibold uppercase tracking-[0.06em] text-neutral-500">
            {t("energy.myEnergy")}
          </li>
          {[null, 1, 2, 3, 4, 5].map((e) => (
            <li key={String(e)}>
              <button
                type="button"
                role="option"
                aria-selected={energy === e}
                className={clsx(
                  "flex w-full items-center justify-between rounded-sm px-2 py-1 text-left hover:bg-neutral-100 dark:hover:bg-neutral-800",
                  energy === e && "bg-neutral-100 dark:bg-neutral-800",
                )}
                onClick={() => {
                  setEnergy(e);
                  setOpen(false);
                }}
              >
                <span>{e === null ? t("energy.any") : t(`energy.level${e}`)}</span>
                <span className="font-mono text-neutral-500">{e ?? "–"}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
